<template>
    <div>
        <AboutPage />
    </div>
</template>

<script>
import AboutPage from '../components/About.vue'

export default {
    components: {
      AboutPage,
    },
    data() {
        return {
          
        }
    },
}
</script>

<style lang="scss" scoped>
.footer {
    margin-top: 0;
}
@include h5() {
    .footer {
        margin-top: 0;
    }
}
</style>
